module.exports = __webpack_public_path__ + "static/media/wheat.c7c5f4b6.svg";